import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {ReactComponent as CheckCircleSVG} from "../../../../../images/icons/check-circle.svg";
import {ReactComponent as NoImageSVG} from "../../../../../images/icons/no-image.svg";
import {RootState} from "../../../../../reducers";
import MenuEditItemViewHelper from "../../../../services/Menu/services/ItemView/MenuEditItemViewHelper";
import Money from "../../../../components/Common/Money";
import AppConfig from "../../../../services/AppConfig";
import {ReactComponent as PlusSVG} from "../../../../../images/icons/plus.svg";
import {ReactComponent as MinusSVG} from "../../../../../images/icons/minus.svg";
import {createKeyDownHandler} from "../../../../utils/keyDownHanlder";


interface OwnProps {
    disableAdd: any,
    singlePick: any,
    errors: any,
    onEdit: (optionStateItem: any) => void
    stateItem: any,
    modifierGroupId: any,
    optionItemView: any,
    onUpdate: (modifierGroupId: any, optionItemView: any, quantity: any) => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const MenuItemOptionWithImageComponent = (props: Props) => {
    let optionStateItem = props.stateItem;
    let modifierGroupId = props.modifierGroupId;
    let optionItemView = props.optionItemView;
    let price = optionItemView.price;
    let disableAdd = optionItemView.disabled ? true : props.disableAdd ? props.disableAdd : false;
    let singlePick = props.singlePick;
    let quantity = optionStateItem ? optionStateItem.quantity : 0;
    let errors = props.errors;
    const {t} = useTranslation();

    let onClickItem = (e: any) => {

        if (disableAdd) return;
        if (!singlePick) {
            props.onUpdate(modifierGroupId, optionItemView, quantity + 1);
            return;
        }
        if (optionStateItem) {
            props.onUpdate(modifierGroupId, optionItemView, 0);
        } else {
            props.onUpdate(modifierGroupId, optionItemView, 1);
        }
    }

    const subQuantityItem = () => {
        props.onUpdate(modifierGroupId, optionItemView, quantity - 1);
    }
    const addQuantityItem = () => {
        props.onUpdate(modifierGroupId, optionItemView, quantity + 1);
    }
    const renderItemInfo = (optionStateItem: any, optionItemView: any) => {
        let nameOptions = [] as any[];
        if (!optionStateItem.modifier_groups) return null;
        optionStateItem.modifier_groups.forEach((mg: any) => {
            let modifierGroupView = optionItemView.modifier_groups.filter((x: any) => x.id === mg.modifier_group_id)[0];
            mg.selected_items.forEach((mgo: any) => {
                if (mgo.quantity > 0) {
                    let itemView = modifierGroupView.options.filter((x: any) => x.id === mgo.item_id)[0];
                    nameOptions.push(`${mgo.quantity}x${itemView.name}`);
                }
            })
        })
        if (nameOptions.length === 0) return null;
        return (
            <p>
                {nameOptions.join(", ")}
            </p>
        );
    }
    const renderErrors = (errors: any) => {
        return (
            <>
                {errors.map((error: any) => {
                        return (
                            <p className="product-item-modifiers-errors"
                               key={`${modifierGroupId}-${optionItemView.id}-${error.message}-${error.resource ? error.resource : ""}`}>{error.message} {error.resource ? error.resource : ""}</p>
                        )
                    }
                )}
            </>
        )
    }

    const handleOnOptionKeyDown = createKeyDownHandler<HTMLButtonElement>({
        keys: ["Enter", " "],
        preventDefault: true,
        action: () => props.onEdit(optionStateItem)
    })

    const renderMultilevelOption = () => {
        if (!optionStateItem) return null;
        let errors = MenuEditItemViewHelper.getErrors(optionItemView);
        const itemInfo = renderItemInfo(optionStateItem, optionItemView);
        if (errors.length === 0 && !optionItemView.is_customize && itemInfo === null) return null;
        return (
            <div className={"product-option-multilevel"}>
                {itemInfo}
                {renderErrors(errors)}
                {optionItemView.is_customize && (
                    <>
                        {errors.length > 0 ? (
                            <button onKeyDown={handleOnOptionKeyDown} tabIndex={0}
                                    onClick={() => props.onEdit(optionStateItem)}
                                    className={"btn btn-primary w-100"}>
                                {t("modules.menu.action.choose_position.title")}
                            </button>
                        ) : (
                            <button onKeyDown={handleOnOptionKeyDown} tabIndex={0}
                                    onClick={() => props.onEdit(optionStateItem)}
                                    className={"btn btn-primary w-100"}>
                                {t("modules.menu.action.adjust_position.title")}
                            </button>
                        )}
                    </>
                )}
            </div>
        )
    }

    const handleOnKeyDown = createKeyDownHandler<HTMLDivElement>({
        keys: ["Enter", " "],
        preventDefault: true,
        action: (event) => {
            onClickItem(event)
        }
    })

    const handleChangeQuantityOnKeyDown = (subtract?: boolean) => createKeyDownHandler<HTMLDivElement>({
        keys: ["Enter", " "],
        preventDefault: true,
        stopPropagation: true,
        action: () => {
            if (subtract) {
                subQuantityItem();
            } else {
                addQuantityItem();
            }
        }
    })

    return (
        <div className="product-modifier-option1" key={modifierGroupId + "-" + optionItemView.id}>
            <div
                className={`product-option-with-image${optionStateItem ? " active" : ""}${(quantity === 0 && optionItemView.disabled) ? " disabled" : ""}${errors !== undefined && errors.length > 0 ? " error" : ""}`}>
                <div className={"check-circle"}>
                    <CheckCircleSVG/>
                </div>
                <div className={"product-option-body"} tabIndex={0} onClick={onClickItem} onKeyDown={handleOnKeyDown}>
                    <div className={"card-img"}>
                        {optionItemView.image_link ? (
                            <img alt={t("common.word.product_image")}
                                 src={optionItemView.image_link.default}/>
                        ) : (
                            <NoImageSVG/>
                        )}
                    </div>
                    <div className={"product-option-content"}>
                        <h4>
                            {optionItemView.name}
                        </h4>
                        {optionItemView.description && (
                            <p>{optionItemView.description}</p>
                        )}
                        <div className={"product-option-actions"}>
                            <div className={"price"}>
                                {optionStateItem ? (
                                    <>
                                        +<Money
                                        value={optionStateItem.total_price}
                                        currency='PLN'/>
                                        {(quantity > 1 || (AppConfig.isShowFreeInfo() && optionStateItem.quantity_free > 0)) && (
                                            <small>
                                                {" "}
                                                (
                                                {quantity > 1 && (
                                                    <>
                                                        <Money
                                                            value={price}
                                                            currency='PLN'/> {t("modules.menu.field.per_one_item.title")}
                                                    </>
                                                )}
                                                {(AppConfig.isShowFreeInfo() && optionStateItem.quantity_free > 0) && (
                                                    <>
                                                        {quantity > 1 && ", "}
                                                        {optionStateItem.quantity_free} {t("modules.menu.field.charge_above.title").toLowerCase()}
                                                    </>
                                                )}
                                                )
                                            </small>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <Money
                                            value={price}
                                            currency='PLN'/>
                                    </>
                                )}
                            </div>
                            {!singlePick && (
                                <div className={"product-option-quantity"}>
                                    <div className="input-group input-group-sm input-group-quantity">
                                        <div className="input-group-prepend"
                                             onKeyDown={handleChangeQuantityOnKeyDown(true)}>
                                            <button disabled={quantity <= 0}
                                                    className={`btn btn-default btn-sm btn-icon`} type="button"
                                                    id="button-addon1" onClick={(e: any) => {
                                                e.stopPropagation();
                                                subQuantityItem();
                                            }}
                                                    aria-label={`${t("common.action.decrease_quantity")} ${optionItemView.name}`}>
                                                <MinusSVG aria-hidden="true"/>
                                            </button>
                                        </div>
                                        <span className={"input-group-text"}>{quantity}</span>
                                        <div className="input-group-append"
                                             onKeyDown={handleChangeQuantityOnKeyDown()}>
                                            <button disabled={disableAdd}
                                                    className="btn btn-default btn-icon btn-sm"
                                                    type="button" id="button-addon1"
                                                    aria-label={`${t("common.action.increase_quantity")} ${optionItemView.name}`}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        addQuantityItem()
                                                    }}>
                                                <PlusSVG aria-hidden="true"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {(errors !== undefined && errors.length > 0) && (
                    <div className={"product-option-errors"} aria-live="polite">
                        {
                            errors.map((error: any) =>
                                <div className="text-danger error"
                                     key={`${modifierGroupId}-${optionItemView.id}-${error.message}`}>{error.message}</div>
                            )
                        }
                    </div>
                )}
                {optionItemView.disabled && optionItemView.quantity === 0 && (
                    <div className={"product-option-errors"} aria-live="polite">
                        <div className="text-danger error">{t("constraints.internal.item_not_available")}</div>
                    </div>
                )}
                {renderMultilevelOption()}
            </div>
        </div>
    )

}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuItemOptionWithImageComponent));